import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=6cad1c3d&scoped=true&"
import script from "@/views/Subjects/FileUpload.ts?vue&type=script&lang=ts&"
export * from "@/views/Subjects/FileUpload.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Subjects/file-upload.scss?vue&type=style&index=0&id=6cad1c3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad1c3d",
  null
  
)

export default component.exports